// Сервіс для глобального показу Snackbar
type SnackbarCallback = (message: string) => void;

let snackbarCallback: SnackbarCallback | null = null;

export const setSnackbarCallback = (callback: SnackbarCallback) => {
  snackbarCallback = callback;
};

export const showErrorSnackbar = (message: string) => {
  if (snackbarCallback) {
    snackbarCallback(message);
  }
};
